module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/logo-c90d6664d5f8779dfb80a5fa6d4d0fa8.svg";